import I18n from 'I18n';
// @ts-expect-error getNativeCurrencySymbol not typed
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';

/**
 * Returns the number of decimal digits for the currency. Defaults to 2.
 *
 * @param {object} currencySymbols
 * @param {string} lineItemCurrencyCode
 *
 * @returns {number} The number of decimal digits for the currency
 */
export function getDecimalDigits({
  currencyCode
}) {
  const currencySymbols = I18n.currencySymbols;
  const symbolData = currencySymbols[currencyCode];
  if (!symbolData) return 2;
  return getDecimalPrecision(currencySymbols, currencyCode);
}
export function getDecimalPrecision(currencySymbols = {}, /** @FIXME emitted-types stop allowing undefined */
lineItemCurrencyCode) {
  if (!lineItemCurrencyCode) {
    return 2;
  }

  // @ts-expect-error currencySymbols not typed
  const currencyInfo = currencySymbols[lineItemCurrencyCode];
  return currencyInfo ? currencyInfo.alternative_decimal_digits || currencyInfo.decimal_digits : 2;
}
export function getCurrencySymbol(currency, isNativeCurrency = false) {
  const symbolData = I18n.currencySymbols[currency];
  if (!symbolData) return currency;
  if (isNativeCurrency) {
    var _getNativeCurrencySym;
    return (_getNativeCurrencySym = getNativeCurrencySymbol(currency)) !== null && _getNativeCurrencySym !== void 0 ? _getNativeCurrencySym : symbolData.symbol;
  } else {
    var _symbolData$symbol;
    return (_symbolData$symbol = symbolData.symbol) !== null && _symbolData$symbol !== void 0 ? _symbolData$symbol : currency;
  }
}